import styles from "./style.module.scss";
import Comparisons from "./comparisons";
import Modal from "@components/shared/modal";
import Portal from "src/portals/Portal";
import { useAtom } from "jotai";
import { showModal } from "@store/categoryStore";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import CompareList from "./compareList";
import PlusIcon from "./plusIcon";
import Button from "@components/shared/form/button";
import { GQLOffers } from "@gql/types/gql";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

export default function Compare({
    offersToCompare,
    title,
    pageTitle = "",
}: {
    offersToCompare?: GQLOffers[];
    title?: string;
    pageTitle?: string;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const [modalVisibility, setModalVisibility] = useAtom(showModal);

    const [comparisonList, setComparisonsList] = useState([
        ...(offersToCompare ?? []),
    ]);
    const upDateList = (value: GQLOffers[]) => {
        setComparisonsList(value);
    };

    const showModalClickHandler = () => {
        setModalVisibility(true);
    };

    return (
        <>
            <section className="my-16">
                <h1 className=" lg:text-3xl text-xl lg:leading-[54px] leading-9 text-center font-bold">
                    {pageTitle
                        ? pageTitle
                        : title
                        ? title
                        : translate(
                              translations,
                              "several_comparePage_compareBetweenVendors",
                          )}
                </h1>

                <h2
                    className={`${styles["paragraphColor"]}  lg:text-xl text-sm  lg:leading-9 leading-6 text-center `}
                >
                    {translate(
                        translations,
                        "several_comparePage_pressAddCompare",
                    )}
                </h2>
                <Comparisons
                    comparisonList={comparisonList}
                    upDateList={upDateList}
                />
                {modalVisibility && (
                    <Portal>
                        <Modal
                            className={`lg:w-[38%] w-full lg:max-w-xl ${styles["drawer"]}`}
                            showOuterClose={true}
                            outerCloseButtonClassName={
                                styles["outer-close-button"]
                            }
                        >
                            <CompareList comparisonList={comparisonList} />
                        </Modal>
                    </Portal>
                )}

                <span
                    className={`${styles["plusIcon"]} ltr:right-0 rtl:left-0 rtl:rotate-180`}
                    onClick={showModalClickHandler}
                >
                    <PlusIcon />
                </span>

                {comparisonList?.length > 0 && (
                    <Button
                        onClick={showModalClickHandler}
                        className={`${styles["showAddButton"]} sticky bottom-0 rounded-none py-3 `}
                    >
                        {translate(
                            translations,
                            "several_comparePage_addCompare",
                        )}
                    </Button>
                )}
            </section>
        </>
    );
}
